import Preloader from '../../../../../ui/svg/common/preloader';
import React, { useState } from 'react';
import { couponActions, rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { getLocalData } from '../../domain/shopping-cart-address-provider';
import { isAuthenticated } from '../../../../membership/dal/data-provider';
import { CartSteps } from '../../enums/cart-steps';
import { getSelectedCartItems } from '../../data/data-provider';
import { checkIsSubscription } from '../../domain/shopping-cart-provider';
import { PaymentTabsEnum } from '../../enums/payment-tabs-enum';
import { getIsChina } from '../../../../../domain/hidden-data-provider';
import { IsAuthReferrer } from '../../../../membership/enums/is-auth-referrer';

interface IProceedToCheckoutBtn{
    classes?: string,
}

const Step1ProceedToCheckoutBtn = (props: IProceedToCheckoutBtn) => {

    const [loading, setLoading] = useState(false);

    const dispatch = useAppDispatch();
    const cartData = useAppSelector(store => store.root.cartData);
    const couponControl = useAppSelector(store => store.coupons.couponControl);
    const selectedCartItems = getSelectedCartItems(cartData);
    const selectedPaymentTab = useAppSelector(store => store.root.selectedPaymentTab);
    const isReferCreditChecked = useAppSelector(store => store.root.isReferCreditChecked);

    /**
     * proceed to checkout
     */
    const proceedHandler = async () => {

        // if coupon text box has a value, and coupon was not submitted,
        // show a validation error
        if(couponControl.value.trim()) {
            dispatch(
                couponActions.main({
                    showCouponNavError: true,
                })
            );
            return;
        }

        // if my rewards checkbox is checked, and the value was not submitted,
        // show a validation error
        if(isReferCreditChecked && cartData.priceData.selectedUserCredit <= 0) {
            dispatch(
                rootActions.main({
                    showCreditNavError: true,
                })
            );
            return;
        }

        setLoading(true);

        const response = await isAuthenticated(IsAuthReferrer.ShoppingCart, getLocalData());

        setLoading(false);

        if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) return;

        if(response.data.relatedData.cartData){

            // update the whole cart data - to update tax, for example
            dispatch(
                rootActions.setCartData(response.data.relatedData.cartData)
            );
        }

        const isUserAuthenticated: boolean = response.data.relatedData.isUserAuthenticated;

        // go to the next step
        dispatch(
            rootActions.main({
                cartStep: isUserAuthenticated ? CartSteps.Third : CartSteps.Second,
            })
        );

        const isSubscription = checkIsSubscription(cartData);
        const isPayPalSelected = selectedPaymentTab === PaymentTabsEnum.PayPal;
        const isAliPaySelected = selectedPaymentTab === PaymentTabsEnum.AliPay;
        if((isSubscription && isAliPaySelected) || (getIsChina() && isPayPalSelected)){
            dispatch(
                rootActions.main({
                    selectedPaymentTab: PaymentTabsEnum.CreditCard,
                })
            );
        }
    };

    return (
        <>
            {
                loading &&
                <div className="flex justify-center my-6">
                    <Preloader width="30px" height="30px" color="#4f4f4f" />
                </div>
            }

            {
                !loading &&
                <>
                    {
                        selectedCartItems.length > 0 &&
                        <button
                            type="button"
                            className={ props.classes }
                            data-qa="cart-step1-proceed-checkout"
                            onClick={ proceedHandler }>Proceed to checkout</button>
                    }

                    {
                        selectedCartItems.length <= 0 &&
                        <>
                            <div className="error-box mt-10 mb-4" role="alert"><p>Select products to purchase</p></div>
                            <button
                                type="button"
                                disabled={ true }
                                className="w-btn xl:text-xl font-normal py-3 whitespace-nowrap bg-gray-200 cursor-default">Proceed to checkout</button>
                        </>
                    }
                </>
            }
        </>
    )
};

export default Step1ProceedToCheckoutBtn;